import React from 'react';
import { motion } from 'framer-motion';
import { rgba } from 'polished';

import { RoundSpanContainer, DotWaveContainer, DotWave } from './styles';
import { tokens } from '../../../design/tokens';

/**
 * Spinner para uso DENTRO do botao dourado.
 *
 * O padrao do Loading e a rampa laranja, que sobre o Ouro de Marquise mede
 * 1.61:1 no arco e 1.17:1 no trilho — o botao fica dourado e vazio durante o
 * envio. Sobre o ouro, a tinta correta e a mesma do rotulo que o spinner
 * substitui: Carvao de Tinta, 8.59:1.
 *
 * Ordem: [trilho, arco, rastro1, rastro2, rastro3].
 */
export const SPINNER_ON_GOLD = [
  rgba(tokens.color.inkCharcoal, 0.2),
  tokens.color.inkCharcoal,
  rgba(tokens.color.inkCharcoal, 0.75),
  rgba(tokens.color.inkCharcoal, 0.5),
  rgba(tokens.color.inkCharcoal, 0.3),
];

const spinTransition = {
  loop: Infinity,
  duration: 1.2,
  easeIn: 0.2,
};

interface LoadingProps {
  customColors?: Array<string>;
  size?: number;
  type?: string;
}

const Loading: React.FC<LoadingProps> = ({
  customColors = [],
  size = 0,
  type = 'round',
}) => {
  const loadingCircleVariants = {
    start: {
      y: '0%',
    },
    end: {
      y: '100%',
    },
  };

  const loadingCircleTransition = {
    duration: 0.4,
    yoyo: Infinity,
    ease: 'easeInOut',
  };

  const loadingContainerVariants = {
    start: {
      transition: {
        staggerChildren: 0.1,
      },
    },
    end: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  return (
    <>
      {type === 'round' && (
        <RoundSpanContainer
          className="round-span"
          customColors={customColors}
          size={size}
          role="status"
          aria-label="Carregando"
        >
          <motion.span animate={{ rotate: 360 }} transition={spinTransition} />
        </RoundSpanContainer>
      )}
      {type === 'ellipsis' && (
        <DotWaveContainer
          variants={loadingContainerVariants}
          initial="start"
          animate="end"
        >
          <DotWave
            variants={loadingCircleVariants}
            transition={loadingCircleTransition}
          />
          <DotWave
            variants={loadingCircleVariants}
            transition={loadingCircleTransition}
          />
          <DotWave
            variants={loadingCircleVariants}
            transition={loadingCircleTransition}
          />
        </DotWaveContainer>
      )}
    </>
  );
};

export default Loading;
